<template>
  <DialogContent>
    <div
      class="size-[126px] flex items-center justify-center bg-gray-200/30 rounded-xl mx-auto mt-4 mb-8"
    >
      <Lottie name="New-File" class="min-w-[160px]" />
    </div>

    <div class="font-semibold font-primary text-[17px] text-center mb-4">
      You're uploading your first file with Dacr Pro
    </div>

    <div class="text-[14px] mb-2.5">
      You can add an unlimited amount of files for copyright protection.
    </div>

    <div class="text-[13px]">
      Based on your subscription, each file you add for copyright protection
      will be billed to you at
      <span class="font-primary font-semibold">
        {{ pricePerFile }}
      </span>
      per copyright for the lifetime of your account. Your card will be charged
      the total amount due for the amount of copyrights added.
    </div>
  </DialogContent>
  <DialogFooter>
    <UiButton
      class="w-1/2 tablet-h:w-auto mr-2.5 tablet-h:mr-2"
      @click="close()"
    >
      Cancel upload
    </UiButton>
    <UiButton class="w-1/2 tablet-h:w-auto" primary @click="handleClick">
      Continue
    </UiButton>
  </DialogFooter>
</template>

<script setup lang="ts">
import { UiButton } from '@dacr/ui'
import DialogContent from '@/shared/dialogs/DialogContent.vue'
import DialogFooter from '@/shared/dialogs/DialogFooter.vue'
import { useDialog } from '@/shared/dialogs/useDialog'
import { BillingPriceType } from '@/shared/graphql/legacy/generated'
import { useBillingStore } from '@/features/billing/store'
import { formatPrice } from '@/shared/utils/money'
import { computed } from 'vue'
import Lottie from '@/shared/components/Lottie.vue'

const { close, triggerEvent } = useDialog()
const billingStore = useBillingStore()

const pricePerFile = computed(() => {
  const billingPrice = billingStore.billing?.plan.prices.find(
    (price) => price.type === BillingPriceType.File
  )
  const amountInCents = billingPrice?.details.amount || 0

  return `${formatPrice({
    amount: amountInCents / 100,
    currency: billingPrice?.details.currency,
  })}`
})

const handleClick = () => {
  triggerEvent('success')
  close()
}
</script>
